import { useCallback, useState } from "react"

export const useResourceDetailsDialog = () => {
    const [resourceId, setResourceId] = useState<string | null>(null)

    const openResourceDetailsDialog = useCallback((id: string) => setResourceId(id), [])
    const closeResourceDetailsDialog = useCallback(() => setResourceId(null), [])

    return { resourceId, openResourceDetailsDialog, closeResourceDetailsDialog }
}
